import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import "./membershipPremiumPlus.scss"
import ButtonBase from "../../Buttons/ButtonBase";
import { closeModalPayments } from "../../../store/actions/ModalsActions";
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import SignIn from '../../../pages/SignIn/components/Main/SignIn'

const imgCloseModal = "/img/tache.svg";

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: "#484848",
        '& + $track': {
            backgroundColor: "#e7e7e7",
            borderColor: "#e7e7e7",
        },
        '&$checked': {
            transform: 'translateX(12px)',
            color: "#013957",
            '& + $track': {
                opacity: 0.3,
                backgroundColor: "#10587f",
                borderColor: "#10587f",
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);



function MembershipPremiumPlus(props) {
    const history = useHistory();
    
    const [checkedTypePayment, setCheckedTypePayment] = useState(false)
    let { modalPayments, closeModalPayments, role, typeMembershipPayment } = props

    const handleCloseModal = () => {
        closeModalPayments(false)
    }

    const handleChangeSwitch = (event) => {
        setCheckedTypePayment(event.target.checked);
    }

    const handleChangePayments = () => {
      


        let cost = role === "lawyer" ? (modalPayments.typePayment === "sixMonths" ? "1,399" : checkedTypePayment === false ? "1,189" : "14,268") :
        (modalPayments.typePayment === "sixMonths" ? "1,999" : checkedTypePayment === false ? "1,699" : "20,388")
       console.log('cost',cost)
       let time = modalPayments.typePayment =='twelveMonths'  && checkedTypePayment ? 'oneYear' : (modalPayments.typePayment == 'sixMonths' ? 'sixMonths' : 'twelveMonths')
        closeModalPayments(false, modalPayments.membershipRole, modalPayments.typeMembership , time ,cost ,)
      
        history.push('/dashboard/payments') 
    }

    return (
        <>
        {modalPayments && modalPayments.open == true && (<>
            <div className="contentMainMembershipPremium">
           <div onClick={handleCloseModal} className="contentImgClose">
                    <img src={imgCloseModal} alt="close" />
                </div>
            {modalPayments.membershipRole && modalPayments.membershipRole =='noSession' ? (<div><SignIn cardType='withoutCard'/></div>) :
                (<CardM modalPayments={modalPayments} handleChangeSwitch={handleChangeSwitch} handleChangePayments={handleChangePayments}
                     checkedTypePayment={checkedTypePayment} closeModalPayments={closeModalPayments} role={role} typeMembershipPayment={typeMembershipPayment} 
                     handleCloseModal={handleCloseModal} />)}
                
            </div> 
            </>)
}
        </>
    )
}




const CardM = ({modalPayments,handleChangeSwitch, handleChangePayments, checkedTypePayment, closeModalPayments, role, typeMembershipPayment ,handleCloseModal}) => {    

    return ( 
        <>   
       {
           modalPayments.membershipRole == role ? (<> 
                
                <div className="contentDataMembership">
                    <p className="title_modalM marginB14">Confirmar membresía</p>
                    <p className="subTitleTimeMembership">{role === 'lawyer'? 'Abogado: ': 'Despacho: '}<span className="typeMembershipPlus">PREMIUM PLUS</span> {modalPayments.typePayment === "sixMonths" ? "/ semestral" : "/ anual"} </p>
                    <p className="timePermanence"> {modalPayments.typePayment === "sixMonths" ? "Permanencia de 6 meses." : "Permanencia de 1 año."}</p>
                    {modalPayments.typePayment !== "sixMonths" && <div className="contentSwitch">
                        <p className="textMonthly">Mensual</p>
                        <AntSwitch checked={checkedTypePayment} onChange={handleChangeSwitch} name="checkedC" />
                        <p className="oneTimePayment">Pago único</p>
                    </div>}
                    {role === "lawyer" ? <p className="priceMembership"> {modalPayments.typePayment === "sixMonths" ? "$1,399" : checkedTypePayment === false ? "$1,189" : "$14,268"} <span className="nationalCurrency">.-  MXN</span> </p> :
                        <p className="priceMembership"> {modalPayments.typePayment === "sixMonths" ? "$1,999" : checkedTypePayment === false ? "$1,699" : "$20,388"} <span className="nationalCurrency">.-  MXN</span> </p>}
                    <p className="timeTax">{checkedTypePayment ? 'Por año +IVA' : 'Por mes +IVA'}</p>
                </div>
                <div className="goodPositioning">
                    <p className="textPositioning"><span className="textWeight">Buen posicionamiento</span> en listados de búsqueda, por detrás de Premium Plus.</p>
                </div>
                <div className="goodPositioning">
                    <p className="textPositioning"><span className="textWeight">Soporte vía telefónica, WhatsApp o email</span> por parte de nuestros asesores.</p>
                </div>
                {/* <div className="goodPositioning">
                    <p className="textPositioning"><span className="textWeight">Chat directo</span> con los clientes.</p>
                </div> */}
                <div className="contentButtonMembership">
                    <div className="buttonMembership">
                        <ButtonBase
                            onClick={handleChangePayments}
                            variant="primary"
                        >
                            Elegir membresía PREMIUM PLUS
                    </ButtonBase>
                    </div>
                </div>
                </>

):(role== 'lawFirm'?  (<div className='container_modalM '>
    <div className='title_modalM marginB30'>Membresía para abogados</div>
    <p className='text_modalM'>La membresía que deseas obtener es  
<strong> exclusiva para abogados independientes</strong>, actualmente te encuentras registrado como despacho.
Para obtener esta membresía te invitamos a generar 
un <strong>registro como abogado independiente.</strong></p>

    <div className="buttonMembership">
        <ButtonBase
            onClick={handleCloseModal}
            variant="primary"
        >
           Cerrar
        </ButtonBase>
 
</div>
</div>)
    : 
   (<div className='container_modalM '>
   <div className='title_modalM marginB30'>Membresía para despachos</div>
   <p className='text_modalM'>La membresía que deseas obtener es  
<strong> exclusiva para despachos</strong>, actualmente te encuentras registrado como abogado.
Para obtener esta membresía te invitamos a generar 
un <strong>registro como despacho.</strong></p>

   <div className="buttonMembership">
       <ButtonBase
           onClick={handleCloseModal}
           variant="primary"
       >
          Cerrar
       </ButtonBase>

</div>
</div>))

       }
         </>
);
}


const mapDispatchToProps = dispatch => ({
    closeModalPayments: (close, role, typeMembership, typePayment,cost ) => dispatch(closeModalPayments(close,role, typeMembership, typePayment,cost)),
})

const mapStateToProps = (state) => ({
    modalPayments: state.ModalReducer.openModalPayments,
    role: state.authClient.role
});

export default connect(mapStateToProps, mapDispatchToProps)(MembershipPremiumPlus);
